import { scrollToTop } from "util";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";

import styles from "./ScrollToTopButton.module.scss";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    if (window.innerWidth >= 768 && document.documentElement.scrollTop > 1000) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
  }, []);

  return (
    <div className={styles.container} style={{ display: visible ? "inline" : "none" }}>
      <Button onClick={scrollToTop}>
        <FontAwesomeIcon icon="arrow-up" /> Top
      </Button>
    </div>
  );
};

export default ScrollToTopButton;
